// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","355":"7f11451d","453":"03346f77","455":"2281e389","977":"5a4c08f0"}[chunkId] + ".chunk.js";
};